import { render } from "./StartMenu.vue?vue&type=template&id=648470a9"
import script from "./StartMenu.vue?vue&type=script&lang=js"
export * from "./StartMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__